import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { ContentRoute } from 'src/_metronic/layout';
//import NewSession from './NewSession';
import Session from './Session';
import NewSession2 from './NewSession2';
import Visualizer from './Visualizer';
import ConsultSessions from './ConsultSessions/ConsultSessions';
import LoadSessions from './LoadSessions/LoadSessions';
import { authentication } from '../Authentication';
import { useSelector } from 'react-redux';

const SessionsPage = () => {
	const user = useSelector((state) => state.auth.user);

	return (
		<Switch>
			<Redirect exact from="/sesiones" to="/sesiones" />
			<ContentRoute
				exact
				path="/sesiones/consultar-sesiones"
				component={ConsultSessions}
			/>
			<ContentRoute
				exact
				path="/sesiones/consultar-sesiones/sesion/:id"
				component={Session}
			/>
			<ContentRoute path="/sesiones/visualizer" component={Visualizer} />
			{/* INICIO USUARIOS QUE PUEDEN CREAR SESIONES */}
			{authentication.hasRole(
				[
					'ADMINISTRADOR GENERAL',
					'RESPONSABLE DE ORGANO COLEGIADO',
					'SISTEMA',
					'RESPONSABLE DE NEGOCIO',
				],
				user
			) ? (
				<>
					<ContentRoute path="/sesiones/crear-sesion" component={NewSession2} />
					<ContentRoute
						path="/sesiones/cargar-sesiones"
						component={LoadSessions}
					/>
				</>
			) : (
				''
			)}
			{/* FIN USUARIOS QUE PUEDEN CREAR SESIONES */}
		</Switch>
	);
};

export default SessionsPage;
